<template>
<v-container fluid pa-0 mt-10>
  <span class="mdLabel topper d-flex bat turq" style="margin-top: 80px;">Current Projects</span>
  <div class="d-flex justify-center flex-wrap">
    <div 
      class="projCards"
      v-for="(value, name, index) in currentProjects" :key="index">
      <project-card 
        :url="value.url"
        :title="value.title"
        :text="value.text"
        :link="value.link"
        :Projlink="value.Projlink"
        :inApp="value.inApp">
      </project-card>
    </div>
  </div>
  <span class="mdLabel topper d-flex bat turq">Past Projects</span>
  <div class="d-flex justify-center flex-wrap">
    <div 
      class="projCards"
      v-for="(value, name, index) in oldProjects" :key="index">
      <project-card 
        :url="value.url"
        :title="value.title"
        :text="value.text"
        :link="value.link"
        :Projlink="value.Projlink"
        :inApp="value.inApp">
    </project-card>
    </div>
  </div>
  <div class="filler d-flex"></div>
  <!-- <span class="xlLabel d-flex bat drkGrey">Design</span>
  <div class="mdLabel d-flex justify-space-between bat">
    <span class="mdLabel d-flex bat turq">Icons</span>
    <span class="mdLabel d-flex bat purp">Camping Set</span>
  </div>
  <div class="d-flex justify-center flex-wrap">
    <div class="iconConts"
      v-for="(value, name, index) in campingIcons" :key="index">
      <art-card :url="value.url"></art-card>
    </div>
  </div>
  <div class="mdLabel d-flex justify-space-between bat">
    <span class="mdLabel d-flex bat turq">Illustrations</span>
    <span class="mdLabel d-flex bat purp">Illustrator</span>
  </div>
  <div class="d-flex justify-center flex-wrap">
    <div class="illoConts"
      v-for="(value, name, index) in adobeIllos" 
      v-bind:key="index">
      <art-card :url="value.url"></art-card>
    </div>
  </div>
  <div class="mdLabel d-flex justify-space-between bat">
    <span class="mdLabel d-flex bat turq">Illustrations</span>
    <span class="mdLabel d-flex bat purp">Ink</span>
  </div>
  <div class="d-flex justify-center flex-wrap">
    <div class="illoConts"
      v-for="(value, name, index) in inkIllos" 
      v-bind:key="index">
      <art-card :url="value.url"></art-card>
    </div>
  </div> -->
  <div class="filler d-flex"></div>
  <div class="filler d-flex"></div>
  <div class="filler d-flex"></div>
</v-container>
</template>
<!--=============================================================================-->
<!--=================================================================SCRIPTS=====-->
<!--=============================================================================-->
<script>
import ProjectCard from './ProjectCard.vue';
// import ArtCard from './artCard.vue';
import Projects from './Projects.json';
import Arts from './Arts.json';

export default {
  components: { ProjectCard },
  data() {
    return{
      Projects,
      Arts,
			width: window.innerWidth,
      height: window.innerHeight,
      infoH: '0'
    }
  },
  computed: {
    currentProjects() { return this.Projects.filter(d => d.current === true)},
    oldProjects() { return this.Projects.filter(d => d.current === false)},
    campingIcons() { return this.Arts.filter(d => d.kind == 'icon' && d.set == 'camping')},
    adobeIllos() { return this.Arts.filter(d => d.kind == 'illo' && d.set == 'adobe')},
    inkIllos() { return this.Arts.filter(d => d.kind == 'illo' && d.set == 'ink')}
  }
}
</script>
<!--===============================================================================-->
<!--===================================================================STYLING=====-->
<!--===============================================================================-->
<style>
.xlLabel{
  text-align: left;
  margin: 1.5vh 4vw;
  font-size: calc(20px + 4vw);}
.mdLabel{
  text-align: left;
  margin: 1vh 4vw;
  font-size: calc(18px + 1.5vw);
  line-height: calc(18px + 1vw);}
.topper{ padding: 1vh 4vw;}
.projCards{
  position: relative;
  margin: 2vw;}
@media screen and (max-width: 960px) { .projCards{ width: 80vw; height: 50vw; }}
@media screen and (min-width: 961px) { .projCards{ width: 40vw; height: 25vw; }}
.iconConts{
  position: relative;
  width: 15vw;
  margin: 1vw;
  min-width: 200px;
  max-width: 300px;
  height: 15vw;
  min-height: 200px;
  max-height: 300px;}
.illoConts{
  position: relative;
  width: 20vw;
  margin: 1vw;
  min-width: 300px;
  max-width: 600px;
  height: 20vw;
  min-height: 300px;
  max-height: 600px;}
.topperz{ margin-top: 80px;}
</style>
